import React from 'react';
import WorkflowSection from '../components/WorkflowSection';

const Workflows = () => {
  return <WorkflowSection />;
};

export default Workflows;
